document.addEventListener('cf:ready', function () {
  var formId = 'xPtRP4';
  var $form = document.querySelector('form[data-cf-form="' + formId + '"]');
  var applicationStartedFired = false;
  var collectedData = {};

  var KLAVIYO_PUBLIC_KEY = 'WLtRYf';
  var KLAVIYO_LIST_ID = 'ScCc2Q';

  $form.addEventListener('cf:field_changed', function (event) {
    var columnKey = event.detail.columnKey;
    var value = event.detail.value;
    collectedData[columnKey] = value;
  });

  function subscribeToKlaviyo(email) {
    fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + KLAVIYO_PUBLIC_KEY, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2025-07-15'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: KLAVIYO_LIST_ID
              }
            }
          }
        }
      })
    }).catch(function (err) {
      console.warn('Klaviyo subscribe request failed:', err);
    });
  }

  $form.addEventListener('cf:step_changed', function (event) {
    var toIndex = event.detail.toIndex;

    if (toIndex === 1 && !applicationStartedFired) {
      var email = collectedData.email || $form.querySelector('[data-cf-column-key="email"]')?.value;

      if (email) {
        klaviyo.identify({
          email: email
        }).then(function () {
          subscribeToKlaviyo(email);

          klaviyo.track('Application Started', {
            form_id: formId,
            submitted_first_name: collectedData.first_name,
            submitted_last_name: collectedData.last_name,
            submitted_email: collectedData.email,
            submitted_phone: collectedData.phone,
            title_or_role: collectedData.title_or_role
          });

          applicationStartedFired = true;
        });
      } else {
        console.warn('Application Started not fired — no email captured. collectedData:', collectedData);
      }
    }
  });

  $form.addEventListener('cf:form_submitted', function (event) {
    var submissionData = event.detail.submissionData;
    var email = submissionData.email || collectedData.email;

    if (email) {
      klaviyo.identify({
        email: email
      }).then(function () {
        klaviyo.track('Application Submitted', {
          form_id: formId
        });
      });
    } else {
      console.warn('Application Submitted not fired — no email found. submissionData:', submissionData);
    }
  });
});


/*
    Note:
    
    The function checks for the availability of the Chatty SDK (`window.$chatty`)
    and retries every 500ms for up to 10 seconds (20 attempts), as the app may
    take time to fully load.

    Once available, it attaches event listeners to track when the chat is opened
    and closed, and publishes corresponding events to Shopify analytics.
*/


function initChattyTracking(attempts = 0) {
    if (attempts > 20) return;
    if (!window.$chatty) {
        setTimeout(() => initChattyTracking(attempts + 1), 500);
        return;
    }
    $chatty.on('chat:opened', function() {
        Shopify.analytics.publish("chatty_chat_opened", {
            timestamp: new Date().toISOString(),
        });
    });
    $chatty.on('chat:closed', function() {
        Shopify.analytics.publish("chatty_chat_closed", {
            timestamp: new Date().toISOString(),
        });
    });
}

let stockistInitialized = false;

function initStockistListener(attempts = 0) {
    if (stockistInitialized) return;
    if (attempts > 20) return;
    const input = window?.Stockist?.__widget?._form?._input;

    if (!input) {
        setTimeout(() => initStockistListener(attempts + 1), 500);
        return;
    }

    stockistInitialized = true;

    let debounceTimer;
    let lastSearch = "";

    input.addEventListener("input", () => {
        clearTimeout(debounceTimer);

        debounceTimer = setTimeout(() => {
            const value = input.value.trim();
            if (!value || value === lastSearch) return;

            lastSearch = value;

            Shopify.analytics.publish("store_locator_search", {
                search_term: value,
                timestamp: new Date().toISOString(),
            });
        }, 2000);
    });
}

document.addEventListener('theme:product:add', (e) => {
    const btn = e.detail?.button;
    if (!btn) return;

    const form = btn.closest('[data-product-form]');
    if (!form) return;

    const isSampleInput = form.querySelector('[name="properties[_is_sample]"]');
    if (!isSampleInput) return;

    Shopify.analytics.publish("swatch_request", {
        timestamp: new Date().toISOString(),
    });
});

document.addEventListener('cf:field_changed', function(event) {
    Shopify.analytics.publish("trade_application_started", {
        timestamp: new Date().toISOString(),
    });
}, {
    once: true
});

document.addEventListener('cf:form_submitted', function(event) {
    const formId = event.detail.formId;
    Shopify.analytics.publish("trade_application_submitted", {
        timestamp: new Date().toISOString(),
        formId,
    });
});




function initDesignerLoginTracking() {
  if (!window.__customerLoggedIn) {
    localStorage.removeItem('designer_login_tracked');
    return;
  }

  const customerTags = (window.__customerTags || []).map(tag =>
    String(tag).trim().toLowerCase()
  );

  if (!customerTags.includes('designer')) return;

  // Intelligems: fire on every pageview
  window.igEvents = window.igEvents || [];
  window.igEvents.push({
    event: 'designer_login'
  });

  const customerId = String(window.__customerId);

  if (localStorage.getItem('designer_login_tracked') === customerId) return;

  localStorage.setItem('designer_login_tracked', customerId);

  const eventData = {
    timestamp: new Date().toISOString(),
    user_id: window.__customerId
  };

  Shopify.analytics.publish('designer_login', eventData);

  window.dispatchEvent(new CustomEvent('designer_login', {
    detail: eventData
  }));
}

function initDealerLoginTracking() {
  if (!window.__customerLoggedIn) {
    localStorage.removeItem('dealer_login_tracked');
    return;
  }

  const customerTags = (window.__customerTags || []).map(tag =>
    String(tag).trim().toLowerCase()
  );

  if (!customerTags.includes('dealer')) return;

  // Intelligems: fire on every pageview
  window.igEvents = window.igEvents || [];
  window.igEvents.push({
    event: 'dealer_login'
  });

  const customerId = String(window.__customerId);

  if (localStorage.getItem('dealer_login_tracked') === customerId) return;

  localStorage.setItem('dealer_login_tracked', customerId);

  const eventData = {
    timestamp: new Date().toISOString(),
    user_id: window.__customerId
  };

  Shopify.analytics.publish('dealer_login', eventData);

  window.dispatchEvent(new CustomEvent('dealer_login', {
    detail: eventData
  }));
}


document.addEventListener("DOMContentLoaded", function() {
    initChattyTracking();
    initStockistListener();
    initDesignerLoginTracking();
    initDealerLoginTracking();

    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(function(swat) {
    if (swat.evtLayer) {
        swat.evtLayer.addEventListener('sw:addedtowishlist', function(e) {
        Shopify.analytics.publish("added_to_wishlist", {
            product_id: e.detail?.d?.empi,
            timestamp: new Date().toISOString(),
        });
        });

        swat.evtLayer.addEventListener('sw:removedfromwishlist', function(e) {
        Shopify.analytics.publish("removed_from_wishlist", {
            product_id: e.detail?.d?.empi,
            timestamp: new Date().toISOString(),
        });
        });
    }
    });
});